import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WorkOrderFormUnsavedChangesGuard } from '@vendasta/work-order';
import { OrderConfirmationPageComponent } from './confirmation-page/order-confirmation-page/order-confirmation-page.component';
import { ActivationParamService } from './core/activation-param.service';
import { DynamicOrderFormPageComponent } from './dynamic-order-form-page/dynamic-order-form-page.component';
import { OrderFormPageComponent } from './order-form-page/order-form-page/order-form-page.component';
import { OrderSubmittedPageComponent } from './order-submitted-page/order-submitted-page.component';
import { ActivationSelectionPageComponent } from './selection-page/activation-selection-page.component';

const routes: Routes = [
  // ActivationParamService used as resolver because I want the route and query params in the service
  {
    path: '',
    component: ActivationSelectionPageComponent,
    resolve: { accountGroupId: ActivationParamService },
  },
  {
    path: 'dynamic-order-form',
    component: DynamicOrderFormPageComponent,
    resolve: { accountGroupId: ActivationParamService },
  },
  {
    path: 'order-form',
    component: OrderFormPageComponent,
    resolve: { accountGroupId: ActivationParamService },
  },
  {
    path: 'confirmation',
    component: OrderConfirmationPageComponent,
    resolve: { accountGroupId: ActivationParamService },
  },
  {
    path: 'order-submitted-page',
    component: OrderSubmittedPageComponent,
    resolve: { accountGroupId: ActivationParamService },
    canDeactivate: [WorkOrderFormUnsavedChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ActivationRoutingModule {}
